import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.NetSuiteBillPaymentRequestForm.NetSuiteBillPaymentBillsSection.AddBillsPopup.BillsFilter',
    {
        title: 'Filter',
        note: 'Please notice that NetSuite Bill Payments can only include Bills or Expense Reports in Approved status.',
        referenceFieldPlaceholder: 'Enter Reference...',
        dateFieldLabel: 'Date',
        fromFieldLabel: 'From',
        toFieldLabel: 'To',
        referenceFieldLabel: 'Reference',
        amountDueFieldLabel: 'Amount due ({currency})',
        originalAmountFieldLabel: 'Original amount ({currency})',
        dueDateFieldLabel: 'Due date',
        resetButtonText: 'Reset filters',
        applyButtonText: 'Apply filters',
        dateFromCantBeAfterDateTo: 'The "from" date must be earlier than the "to" date',
    }
);
